import { JobType as JobApiType } from 'src/api/generated/touring/types';
import { JobType } from '../../../../types';

export const mapJob = (apiJob: JobApiType | null): JobType | null => {
  if (!apiJob) {
    return null;
  }

  return {
    id: apiJob.id,
    isRemote: apiJob.isRemote,
    isConfirmed: apiJob.isConfirmed,
  };
};
